module.exports = __webpack_public_path__ + "static/media/bell-agogo3.23042fe4.aac";